import type { MailUser } from '../types';

/**
 * Wer darf im Mailtool was? Spiegelt nur die Regeln der Datenbank
 * (Migration 0039: mail_rolle_von, Policies, mail_freigabe_schritt) —
 * entschieden wird dort. Die Oberfläche blendet damit nur aus, was ohnehin
 * nicht ginge.
 */

/** Geschäftsführung und Studioleitung: bereiten vor und reichen ein. */
export function istEinreicher(u: MailUser | null | undefined): boolean {
  return !!u && (u.role === 'geschaeftsfuehrung' || u.role === 'studio_leiter');
}

/** Das Kampagnen-Team (voller Zugriff auf Kampagnen, Gruppen, Kontakte). */
export function istTeam(u: MailUser | null | undefined): boolean {
  return !!u && !u.ohneRolle && (u.role === 'admin' || u.role === 'redakteur' || u.role === 'viewer');
}

/**
 * Wohin eine Mail führt, die nicht aus dem Assistenten kommt (Kampagnen-Editor,
 * Event Manager): das Team in den Kampagnen-Editor, Geschäftsführung und
 * Studioleitung auf „Geplante Mails“ — dort ansehen, kommentieren und
 * Änderungen vorschlagen; übernommen wird über die Redaktion (OG73).
 */
export function editorPfad(u: MailUser | null | undefined, id: string): string {
  return istTeam(u) ? `/campaigns/${id}` : `/geplante-mails/${id}`;
}

/** Darf Mails im Assistenten vorbereiten. */
export function kannVorbereiten(u: MailUser | null | undefined): boolean {
  return !!u && !u.ohneRolle && u.role !== 'viewer';
}

/** Redaktion: gibt eingereichte Mails frei (Admins immer). */
export function istRedaktion(u: MailUser | null | undefined): boolean {
  return !!u && !u.ohneRolle && (u.role === 'admin' || u.canApprove);
}

export function rollenText(u: MailUser | null | undefined): string {
  if (!u || u.ohneRolle) return 'Kein Zugang';
  switch (u.role) {
    case 'admin': return 'Administrator';
    case 'redakteur': return u.canApprove ? 'Redaktion (mit Freigaberecht)' : 'Redaktion';
    case 'geschaeftsfuehrung': return 'Geschäftsführung';
    case 'studio_leiter': return 'Studioleitung';
    case 'viewer': return 'Nur lesen';
    default: return u.role;
  }
}
